<template>
  <section class="fa-table press-table py2 sans mx-auto" :class="{ 'border-top': showTitle }">
    <h3 class="sm-hide md-hide lg-hide mb3 red" v-if="showTitle">Press</h3>
    <div class="row clearfix mxn2" :class="{ 'px2': !showTitle }">
      <div class="col xs-hide sm-col-4 px2" v-if="showTitle">Press</div>
      <div class="col" :class="{ 'col col-12 sm-col-8 px2': showTitle, 'col-12': !showTitle }">
        <div v-for="(item, index) in contentSorted"
          class="hover-red row clearfix mxn2 mb2" :key="index">
          <a :href="getLink(item)" target="_blank">
            <div class="col tabular px2" :class="{ 'col-6': showTitle, 'col-4': !showTitle }">{{ pressDate(item) }}</div>
            <div class="col px2" :class="{ 'col-6': showTitle, 'col-8': !showTitle }">
              <span v-if="item.publication" v-html="item.publication" />
              <span v-else-if="item.acf && item.acf.publication" v-html="item.acf.publication" />
              <span v-else>&mdash;</span>
              <br />
              <em v-html="item.post_title || item.title.rendered"></em>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formatDate } from '@/utils'

export default {

  name: 'PressTable',

  data () {
    return {

    }
  },

  props: ['content', 'showTitle'],

  methods: {
    formatDate,
    pressDate (item) {
      if (item.hasOwnProperty('acf') && item.acf.date) {
        return this.formatDate(item.acf.date)
      } else {
        return this.formatDate(item.date)
      }
    },
    getLink (item) {
      if (item.hasOwnProperty('acf')) {
        return item.acf.link
      } else {
        return item.url || item.link
      }
    }
  },

  computed: {
    contentSorted () {
      return this.content.slice().sort((a, b) => {
        if (a.hasOwnProperty('acf') && b.hasOwnProperty('acf')) {
          if (a.acf.date > b.acf.date) {
            return -1
          } else {
            return 1
          }
        } else {
          if (a.date > b.date) {
            return -1
          } else {
            return 1
          }
        }

      })
    }
  }
}
</script>

<style lang="css" scoped>
  .press-table {
    max-width: var(--max-width-med);
    /*font-size: var(--font-size-reader);*/
    line-height: var(--line-height-reader);

    a:hover {
      color: var(--red);
    }
  }
</style>
